/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleFormValidationData
 */
export interface BCMOsisRuleFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMOsisRuleFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMOsisRuleFormValidationData
     */
    marketingCarriers?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMOsisRuleFormValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof BCMOsisRuleFormValidationData
     */
    readonly dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof BCMOsisRuleFormValidationData
     */
    readonly fareBasisCodes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMOsisRuleFormValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMOsisRuleFormValidationData
     */
    osIs?: ValidationMessage;
}

export function BCMOsisRuleFormValidationDataFromJSON(json: any): BCMOsisRuleFormValidationData {
    return BCMOsisRuleFormValidationDataFromJSONTyped(json, false);
}

export function BCMOsisRuleFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : ValidationMessageFromJSON(json['marketingCarriers']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'osIs': !exists(json, 'osIs') ? undefined : ValidationMessageFromJSON(json['osIs']),
    };
}

export function BCMOsisRuleFormValidationDataToJSON(value?: BCMOsisRuleFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'marketingCarriers': ValidationMessageToJSON(value.marketingCarriers),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'osIs': ValidationMessageToJSON(value.osIs),
    };
}


